module.exports = __webpack_public_path__ + "static/media/lah-logo.920d33ed.png";